import { useMessageContext } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';
import { Avatar } from '@bizzabo/collaboration-common';

interface ReplyAvatarListProps {
    maxAvatars?: number;
}

const ReplyAvatarList: React.FC<ReplyAvatarListProps> = ({ maxAvatars = 3 }) => {
    const classes = useStyles();
    const { message } = useMessageContext();

    return (
        <div className={classes.avatarsList}>
            {message.thread_participants.slice(0, maxAvatars).map(user => (
                <Avatar
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    alt={user.firstName}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    src={user.photoUrl}
                    className={classes.avatar}
                    size={22}
                    key={user.id}
                />
            ))}
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        avatar: {
            marginLeft: -8,
            border: `2px solid ${theme.palette.greys[100]}`,
        },
        avatarsList: {
            position: 'relative',
            paddingRight: 12,
            left: 6,
        },
    }),
    { classNamePrefix: 'reply-avatar-list' }
);

export default ReplyAvatarList;
